// Angular imports
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// Models
import { ContextLocationViewModel } from "src/app/_core/models/main/context-location.model";
import { LinkItem } from "src/app/_core/models/main/link-item.model";

// Services
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { Policies } from "src/app/_core/models/main/policies.enum";
import { GlobalService } from "src/app/_core/providers/global.service";
import { getHomeMenu } from "src/app/_core/constants/menu.constants";

@Component({
	selector: "app-example-page",
	templateUrl: "./example.page.html",
	styleUrls: ["./example.page.scss"],
})
export class ExamplePageComponent implements OnInit, OnDestroy {
	// Main
	public contextLocation: ContextLocationViewModel;
	private readonly menu: LinkItem[] = getHomeMenu();
	private readonly destroy$ = new Subject<void>();

	// Data

	constructor(
		//private exampleService: ExampleService, // This doesn't exist, it's just an example
		private readonly activatedRoute: ActivatedRoute,
		private readonly translateService: TranslateService,
		private readonly globalService: GlobalService
	) {}

	// Events
	ngOnInit(): void {
		this.initializePage();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	// Private methods

	private initializePage(): void {
		// Determine the context location
		this.contextLocation = {
			country: "",
			countryName: "",
			cebe: 0,
			serviceName: "",
			centro: 0,
			siteName: "",
		};

		// Set the header options (menu and breadcrumb)
		this.globalService.setHeaderOptions(
			[],
			this.contextLocation,
			[],
			this.menu
		);

		// Get the data
		this.getData();
	}

	private getData() {
		this.getServices(); // Or whatever it is you need to do
	}

	private getServices() {
		// TODO: Implement service data retrieval when needed
	}
}
